import React from 'react';
import PropTypes from 'prop-types';
import { txStatusClass } from './fairModel';

// Статусы, в которых деньги реально зачислены продавцу (есть осмысленная комиссия).
const SETTLED = new Set(['COMPLETED', 'LOSE']);

const fmtSigned = (n) => {
    if (n > 0) return `+${n}`;
    if (n < 0) return `−${Math.abs(n)}`;
    return '0';
};

// Строка транзакции (.fr-txline): покупатель, команды, точка, статус и разбивка сумм.
// Δ баланса продавца берём напрямую из sellerDelta (бэк отдаёт знаковое поле) — корректно
// для любого статуса (WIN: продавец платит → −X). Комиссию НЕ реконструируем вручную.
export default function TransactionLine({ tx, teamName, colorOf, pointName }) {
    const subsidyAmount = tx.subsidy?.amount || 0;
    const total = tx.amount + subsidyAmount;

    // sellerDelta — каноничное знаковое поле; fallback на старый расчёт, пока бэк не задеплоен.
    const sellerDelta = tx.sellerDelta != null ? tx.sellerDelta : (total - (tx.commission || 0));
    const commission = SETTLED.has(tx.status) ? Math.max(0, total - sellerDelta) : 0;
    const sellerCls = sellerDelta > 0 ? 'green' : sellerDelta < 0 ? 'clay' : '';

    return (
        <div className="fr-txline">
            <span className="tid">#{tx.id}</span>
            <div className="fr-txmain">
                {tx.buyerUsername && <span className="usr">{tx.buyerUsername}</span>}
                <span className="teams">
                    <span className="bdot" style={{ background: colorOf(tx.fromTeamStateId) }} />{teamName(tx.fromTeamStateId)}
                    <span className="arr">→</span>
                    <span className="bdot" style={{ background: colorOf(tx.toTeamStateId) }} />{teamName(tx.toTeamStateId)}
                </span>
                {pointName && tx.pointId != null && <span className="pt">{pointName(tx.pointId)}</span>}
                <span className={`fr-badge sm ${txStatusClass(tx.status)}`}>{tx.status}</span>
            </div>
            <div className="grp">
                <span className="mny"><i>студент</i>{tx.amount}</span>
                <span className="mny green"><i>ЦБ +</i>{subsidyAmount}</span>
                <span className="mny"><i>итого</i>{total}</span>
                <span className="mny clay"><i>комиссия</i>{commission ? `−${commission}` : 0}</span>
                <span className={`mny ${sellerCls}`}><i>продавец</i>{fmtSigned(sellerDelta)}</span>
            </div>
        </div>
    );
}

TransactionLine.propTypes = {
    tx: PropTypes.shape({
        id: PropTypes.number,
        status: PropTypes.string,
        amount: PropTypes.number,
        commission: PropTypes.number,
        buyerDelta: PropTypes.number,
        sellerDelta: PropTypes.number,
        fromTeamStateId: PropTypes.number,
        toTeamStateId: PropTypes.number,
        pointId: PropTypes.number,
        buyerUsername: PropTypes.string,
        subsidy: PropTypes.shape({ amount: PropTypes.number })
    }).isRequired,
    teamName: PropTypes.func.isRequired,
    colorOf: PropTypes.func.isRequired,
    pointName: PropTypes.func
};

TransactionLine.defaultProps = { pointName: null };
